import React, { useEffect } from 'react';
import classnames from 'classnames/bind';
import classNames from 'classnames';
import { history, useParams, useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Modal } from '@/components';
import { RootStore } from '@/models';
import Style from './ipad.less';
import FeedbackBtn from './H5/Feedback';
import AudioBtn from './H5/Microphone';
import CameraBtn from './H5/Camera';
import UnReadChatPopover from './H5/Chat/UnReadChatPopover';
import ChatBtn from './H5/Chat';
import RecordingBtn from './H5/Recording';
import SimultaneousInterpretationBtn from './H5/SimultaneousInterpretation';
import LeaveBtn from './H5/Leave';
import Member from './Ipad/Member';

const $c = classnames.bind(Style);

interface ControlProps extends Partial<Pick<RootStore, 'chat' | 'meeting' | 'user'>> {
  RTCInstance?: RootStore['rtc'];
  simultaneous?: RootStore['simultaneousInterpretation'];
  meeting?: RootStore['meeting'];
}
interface ParamsStruct {
  meetingId: string;
}

const ControlBar: React.FC<ControlProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    RTCInstance: store.rtc,
    chat: store.chat,
  };
})(
  observer((props) => {
    const { meeting, RTCInstance, chat } = props;
    const [isChatPopoverVisible, setIsChatPopoverVisible] = React.useState(false);
    const { meetingId } = useParams<ParamsStruct>();
    const { formatMessage } = useIntl();

    useEffect(() => {
      if (RTCInstance?.rtcTrackEnded) {
        Modal.info({
          title: formatMessage({ id: 'DEVICE_IS_ABNORMAL' }),
          okText: formatMessage({ id: 'REFRESH' }),
          okButtonProps: {
            className: `btn-blue`,
          },
          onOk() {
            history.go(0);
          },
        });
      }
    }, [RTCInstance?.rtcTrackEnded]);

    const chatPanelBtnClick = React.useCallback(
      (e, locateMsg = false) => {
        if (RTCInstance?.breakLineReconnecting) {
          return;
        }
        if (!chat?.isAbleUse) return;
        setIsChatPopoverVisible(false);
        e.nativeEvent.stopImmediatePropagation();
        chat?.setChatVisible(!chat?.chatVisible, locateMsg);
        chat?.chatVisible && meeting?.setPeoplePanelShow(false);
      },
      [chat, RTCInstance]
    );

    return (
      <div className={classNames($c('control-bar'), 'ipad-controllbar')}>
        <div className={$c('left')}>
          <AudioBtn />
          <CameraBtn />
        </div>

        <div className={$c('control-group')}>
          <Member></Member>
          <UnReadChatPopover
            onPopoverVisibleChange={setIsChatPopoverVisible}
            popoverVisible={isChatPopoverVisible && !chat?.chatVisible}
            onClick={(e) => {
              chatPanelBtnClick(e, true);
            }}
          >
            <ChatBtn
              onClick={(e) => {
                chatPanelBtnClick(e, false);
              }}
            />
          </UnReadChatPopover>
          <RecordingBtn />
          <SimultaneousInterpretationBtn />
          <FeedbackBtn />
        </div>
        <div className={$c('right')}>
          <LeaveBtn meetingId={meetingId} />
        </div>
      </div>
    );
  })
);

export default ControlBar;
